import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const PLAYER_KEY = "numex_player_id";

export function getPlayerId() {
  let id = null;
  try {
    id = localStorage.getItem(PLAYER_KEY);
  } catch (e) {
    /* ignore */
  }
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `p_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    try {
      localStorage.setItem(PLAYER_KEY, id);
    } catch (e) {
      /* ignore */
    }
  }
  return id;
}

export function getTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
}

export async function startSession(playerId) {
  const { data } = await axios.post(`${API}/session`, {
    player_id: playerId,
    timezone: getTimezone(),
  });
  return data;
}

export async function submitGuess(playerId, guess) {
  const { data } = await axios.post(`${API}/puzzle/guess`, {
    player_id: playerId,
    guess,
    timezone: getTimezone(),
  });
  return data;
}

export async function fetchStats(playerId) {
  const { data } = await axios.get(`${API}/stats/${playerId}`);
  return data;
}
